import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context("./", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}
function getCountryLang() {
  // const country = JSON.parse(localStorage.getItem("myTeam_Dash_user_country"));
  const countryString = localStorage.getItem("myTeam_Dash_user_country");
  const country = countryString ? JSON.parse(countryString) : null;
  // console.log("Detected country:", country.name);

  if (
    country?.name == "المانيا"
    // country?.name == "مصر" ||
    // country === null ||
    // country === "null" ||
    // country === ""
  ) {
    return "de";
  } else {
    return "en";
  }
}
export default new VueI18n({
  // locale: localStorage.getItem("myTeam_Academy_Dash_Lang") || "en",
  locale: getCountryLang(),
  fallbackLocale: localStorage.getItem("myTeam_Academy_Dash_Lang") || "ar",
  messages: loadLocaleMessages(),
});
